import type {VectorCustomization} from '@yandex/ymaps3-types'
import {useEffect, useState} from 'react'

/**
 * Хук для загрузки стилей карты в зависимости от темы.
 * Обходит кеширование в packages/blocks/map/Map.hooks.ts
 */
export const useMapTheme = (theme?: 'light' | 'dark'): VectorCustomization | null => {
  const [customization, setCustomization] = useState<VectorCustomization | null>(null)

  useEffect(() => {
    let isMounted = true
    const effectiveTheme = theme || 'light'

    import(
      /* webpackChunkName: "map-style-[request]" */
      `@yandex-delivery/blocks/map/assets/style-${effectiveTheme}.json`
    )
      .then(module => {
        if (isMounted) {
          setCustomization(module.default)
        }
      })
      .catch(err => {
        console.error('[useMapTheme] Failed to load style:', err)
      })

    return () => {
      isMounted = false
    }
  }, [theme])

  return customization
}
